<template>
  <vs-popup class="popup-select-736"
    title="공정분류표(직영)"
    :active.sync="showPopup">
    <keep-alive>
      <page736 
        v-if="hasLoadedOnce"
        ref="page736" 
        mode="popup" 
        @close="showPopup = false" 
        @select="onSelect"
      />
    </keep-alive>
  </vs-popup>
</template>

<script>
import page736 from "@/views/boards/single-page/736/Page.vue";
export default {
  components: {
    page736
  },
  props: {
    value: Boolean,
  },
  watch: {
    value (val) {
      if (val) {
        // 팝업이 열릴 때
        if (!this.hasLoadedOnce) {
          // 처음 열릴 때만 컴포넌트 마운트 + 데이터 로딩
          this.hasLoadedOnce = true;
          this.$nextTick(() => {
            if (this.$refs.page736) {
              this.$refs.page736.loadPostListInPage();
            }
          });
        }
        // 두 번째부터는 keep-alive로 캐시된 컴포넌트 재사용
      }
      // 팝업이 닫힐 때 (val === false)는 reset 하지 않음 (캐시 유지)
    }
  },
  computed: {
    showPopup: {
      get () {
        return this.value;
      },
      set (val) {
        this.$emit('input', val);
      },
    }
  },
  data () {
    return {
      hasLoadedOnce: false  // 한 번이라도 로드되었는지 추적
    }
  },
  methods: {
    onSelect (model) {
      this.$emit('select', model);
      this.showPopup = false;
    }
  }
}
</script>

<style scoped>

</style>

<style>
.popup-select-736 > .vs-popup {
  width: 1200px !important;
}
</style>
